import { Field, useFormikContext } from 'formik';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormikCheckbox } from '../../../../../components/prime-formik';

const SuperMatchWorkplaceDetailsOpenToAllPreferencesInput = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div className='margin-bottom-0-5'>
      <FormattedMessage
        id="account.super-profiles.new.workplace-location.type.open-to-all-preferences"
        defaultMessage="We are open to all preferences"
        tagName="label"
      >
        {(text) => (
          <Field
            name="workplaceDetailsType"
            checked={values.workplaceDetailsType === 'OPEN_TO_ALL_PREFERENCES'}
            component={FormikCheckbox}
            setFieldValue={() => {
              setFieldValue('workplaceDetailsType', 'OPEN_TO_ALL_PREFERENCES');
            }}
            labelText={text}
          />
        )}
      </FormattedMessage>
    </div>
  );
};

export default SuperMatchWorkplaceDetailsOpenToAllPreferencesInput;
